import React, { useEffect, useState } from 'react';
import { animated, config, useTransition } from 'react-spring';
import styled from 'styled-components';

const WORDS = [
  { id: 0, text: 'full-stack development' },
  { id: 1, text: 'AI-driven automation' },
  { id: 2, text: 'scalable systems design' },
  { id: 3, text: 'cloud-native platforms' },
];

const WordsFading = () => {
  // Subtitle keywords loop
  const windowWidth = window?.innerWidth;
  const [index, setIndex] = useState(0);
  const wordsTransition = useTransition(WORDS[index], (span) => span.id, {
    config: config.stiff,
    delay: 450,
    duration: 100,
    from: {
      opacity: 0,
      transform: 'translateY(10px)',
      position: 'absolute',
      top: 0,
      left: 0,
      margin: 0,
    },
    enter: {
      opacity: 1,
      transform: 'translateY(0px)',
    },
    leave: {
      opacity: 0,
      transform: 'translateY(-10px)',
    },
  });

  useEffect(
    () =>
      setInterval(
        () => setIndex((current) => (current + 1) % WORDS.length),
        2500
      ),
    []
  );

  const Wrapper = styled.div`
    font-weight: 300;
    width: ${windowWidth > 500 ? '260px' : '190px'};
    position: relative;
    display: inline-block;
    text-align: center;
    font-style: italic;
    white-space: nowrap;
    color: #ff4a57;
    transition: color 0.2s ease-out;
    & span {
      text-align: center;
      width: 100%;
    }
  `;

  return (
    <Wrapper>
      <i style={{ visibility: 'hidden' }}>scalable systems design</i>
      {wordsTransition?.map(({ item, props, key }) => (
        <animated.span key={key} style={props}>
          {item?.text}
        </animated.span>
      ))}
    </Wrapper>
  );
};

export default WordsFading;
